export default {
  forecastData: {},
}
